"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("./_internal/Icon"));
var RightArrow2Outlined = /*#__PURE__*/_react["default"].forwardRef(function (ddProps, ref) {
  var props = {};
  var svg = /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    className: "dt__icon",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M327.765 116.373a48 48 0 0165.024-4.416l2.838 2.475L763.2 461.44a69.333 69.333 0 012.816 98.005l-2.795 2.795-367.573 347.307a48 48 0 01-68.565-67.094l2.624-2.666 347.05-327.936-347.05-327.616a48 48 0 01-4.416-65.024l2.474-2.838z"
  }));
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, ddProps, {
    svg: svg,
    ref: ref
  }));
});
RightArrow2Outlined.displayName = "RightArrow2Outlined";
var _default = exports["default"] = RightArrow2Outlined;